import { X, Loader2 } from 'lucide-react';
import React from 'react';

const ConfirmationPopup = ({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-md transition-all duration-300"
    >
      <div
        onClick={(e) => e.stopPropagation()} 
        className="bg-white rounded-2xl shadow-2xl max-w-lg w-full animate-in fade-in zoom-in slide-in-from-bottom-4 duration-300 border border-zinc-100"
      >
        <div className="p-6 pb-4">
          <div className="flex justify-between items-start mb-2">
            <h3 className="text-lg font-semibold text-zinc-900">{title}</h3>
            <button
              onClick={onClose}
              className="cursor-pointer text-zinc-400 hover:text-zinc-600 transition-colors"
              aria-label="Close"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className="border-b border-zinc-200"></div>
          <p className="text-zinc-600 mt-4">{message}</p>
        </div>
        
        <div className="flex justify-end gap-3 px-6 pb-6">
          <button
            onClick={onClose}
            disabled={isLoading}
            className={`cursor-pointer px-4 py-2 text-sm font-medium text-white bg-black rounded-lg transition-all ${
              isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-zinc-800'
            }`}
          >
            {cancelText || 'Cancel'}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`cursor-pointer px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-amber-500 to-orange-500 rounded-lg transition-all flex items-center justify-center gap-2 ${
              isLoading ? 'opacity-70 cursor-not-allowed shadow-none' : 'hover:shadow-md'
            }`}
          >
            {isLoading && <Loader2 className="w-4 h-4 animate-spin" />}
            {isLoading ? 'Processing...' : (confirmText || 'Confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;